{
  "title": "Transient & Tenant Aircraft – {{fboName}}",
  "search": {
    "placeholder": "Search by Tail #, Owner, or Model"
  },
  "filters": {
    "showTenants": {
      "label": "Show Tenants",
      "all": "Show All Tenants",
      "unassigned": "Show Unassigned",
      "assignedTo": "Assigned to {{locationName}}"
    },
    "currentLocation": {
      "label": "Show by Current Location"
    }
  },
  "columns": {
    "tailNumber": "Tail #",
    "ownerManager": "Owner/Manager",
    "model": "Model",
    "currentLocation": "Current Location",
    "assignedLocation": "Assigned Location",
    "type": "Type",
    "lastHangared": "Last Hangared",
    "note": "Note"
  },
  "actions": {
    "edit": "Edit"
  },
  "deleteConfirmation": {
    "title": "Are you sure you want to delete {{identifier}}?",
    "message": "This aircraft will be permanently deleted.",
    "confirm": "Yes"
  },
  "locationText": {
    "notHangared": "Not Hangared"
  }
}
